import { all, takeLatest } from "redux-saga/effects";
import processAction from "../../../../utils/processAction";
import { actionType as customerActionTypes } from "./reducer";
import {
  getCustomers as getCustomersService,
  createCustomer as createCustomerService,
  updateCustomer as updateCustomerService,
  deleteCustomer as deleteCustomerService,
  getProducts as getProductsService,
  assignProduct as assignProductService,
  updateProduct as updateProductService,
  deleteProduct as deleteProductService
} from "./service";

function* getCustomers({ company_id, params }) {
  yield processAction({
    params: { company_id, params },
    service: getCustomersService,
    success: customerActionTypes.GET_CUSTOMER_DATA_SUCCESS,
    failed: customerActionTypes.GET_CUSTOMER_DATA_FAILED
  })
}

function* createCustomer({ company_id, body }) {
  yield processAction({
    params: { company_id, body },
    service: createCustomerService,
    success: customerActionTypes.CREATE_CUSTOMER_DATA_SUCCESS,
    failed: customerActionTypes.CREATE_CUSTOMER_DATA_FAILED
  })
}

function* updateCustomer({ company_id, customer_id, body }) {
  yield processAction({
    params: { company_id, customer_id, body },
    service: updateCustomerService,
    success: customerActionTypes.UPDATE_CUSTOMER_DATA_SUCCESS,
    failed: customerActionTypes.UPDATE_CUSTOMER_DATA_FAILED
  })
}

function* deleteCustomer({ company_id, customer_id }) {
  yield processAction({
    params: { company_id, customer_id },
    service: deleteCustomerService,
    success: customerActionTypes.DELETE_CUSTOMER_DATA_SUCCESS,
    failed: customerActionTypes.DELETE_CUSTOMER_DATA_FAILED
  })
}

function* getProducts({ customer_id, params }) {
  yield processAction({
    params: { customer_id, params },
    service: getProductsService,
    success: customerActionTypes.GET_CUSTOMER_PRODUCTS_SUCCESS,
    failed: customerActionTypes.GET_CUSTOMER_PRODUCTS_FAILED
  })
}

function* assignProduct({ customer_id, body }) {
  yield processAction({
    params: { customer_id, body },
    service: assignProductService,
    success: customerActionTypes.ASSIGN_CUSTOMER_PRODUCT_SUCCESS,
    failed: customerActionTypes.ASSIGN_CUSTOMER_PRODUCT_FAILED
  })
}

function* updateProduct({ customer_id, product_id, body }) {
  yield processAction({
    params: { customer_id, product_id, body },
    service: updateProductService,
    success: customerActionTypes.UPDATE_CUSTOMER_PRODUCT_SUCCESS,
    failed: customerActionTypes.UPDATE_CUSTOMER_PRODUCT_FAILED
  })
}

function* deleteProduct({ customer_id, product_id }) {
  yield processAction({
    params: { customer_id, product_id },
    service: deleteProductService,
    success: customerActionTypes.DELETE_CUSTOMER_PRODUCT_SUCCESS,
    failed: customerActionTypes.DELETE_CUSTOMER_PRODUCT_FAILED
  })
}

function* watchCustomers() {
  yield all([
    takeLatest(customerActionTypes.GET_CUSTOMER_DATA, getCustomers),
    takeLatest(customerActionTypes.CREATE_CUSTOMER_DATA, createCustomer),
    takeLatest(customerActionTypes.UPDATE_CUSTOMER_DATA, updateCustomer),
    takeLatest(customerActionTypes.DELETE_CUSTOMER_DATA, deleteCustomer),
    takeLatest(customerActionTypes.GET_CUSTOMER_PRODUCTS, getProducts),
    takeLatest(customerActionTypes.ASSIGN_CUSTOMER_PRODUCT, assignProduct),
    takeLatest(customerActionTypes.UPDATE_CUSTOMER_PRODUCT, updateProduct),
    takeLatest(customerActionTypes.DELETE_CUSTOMER_PRODUCT, deleteProduct),
  ])
}

export default [watchCustomers()];




// WEBPACK FOOTER //
// ./src/modules/company/pages/customer/saga.js